import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {  ViewChild } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {MaterialModule} from '../../material.module';
import {Sort} from '@angular/material';
import * as Clipboard from 'clipboard';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes, Router} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
import { SetdataService } from '../../services/setdata.service';

@Component({
  selector: 'app-editroom',
  templateUrl: './editroom.component.html',
  styleUrls: ['./editroom.component.css']
})
export class EditroomComponent implements OnInit {

  public submitted:boolean;
  room_id;
  roomdata;

  image_roomlogo;

  editroomname;
  editroomtype;
  editfloornumber;

  constructor(private setDataService:SetdataService, private authService:AuthenticationService, private router:Router,  private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  ngOnInit() {
    this.room_id = this.route.snapshot.paramMap.get('id');  

    this.getdataService.getMeetingRoombyID(this.room_id).subscribe((roomdata) => {
      this.roomdata=  roomdata;
      //////console.log(this.meetingdata[0].event_name);
  
      this.editroomname = this.roomdata[0].room_name;
      this.editroomtype = this.roomdata[0].room_type;
      this.editfloornumber = this.roomdata[0].room_floor_number;
   
      
       this.submitted=false;
        },
      err=>{
        //////console.log(err);
        return false;
      }); 
  }

  public editRoom():void{
    this.submitted=true;
    let files = this.elem.nativeElement.querySelector('#image_roomlogo').files;
    let room_name = this.elem.nativeElement.querySelector('#editroomname').value;
    let room_type = this.elem.nativeElement.querySelector('#editroomtype').value;
    let room_floor_number = this.elem.nativeElement.querySelector('#editfloornumber').value;
    // let end_date = this.elem.nativeElement.querySelector('#end_date').value;

    let formData = new FormData();

    let file = files[0];

    formData.append('room_id',this.room_id);
    formData.append('room_name',room_name);
    formData.append('room_type',room_type);
    formData.append('room_floor_number',room_floor_number);
    

     if(typeof file ==='undefined')
      {
        //////console.log('added image does not have an image');
      
            this.setDataService.SetRoomData(formData).subscribe
            (res =>{
                  this._flashMessagesService.show('Success: Room updated successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

                  ////////refresh category /////////////
                  this.router.navigate(['/admin/rooms']);
                  
                //////////end refresh category.////////
                this.submitted=false;
          } );
      }else{
        //////console.log('added image have an image');

        formData.append('image',file,file.name);
        if(file.size < 10096865)
        {
          
            this.setDataService.SetRoomData(formData).subscribe
            (res =>{
                  this._flashMessagesService.show('Success: Room updated successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

                  ////////refresh category /////////////
                  this.router.navigate(['/admin/rooms']);
                  
                //////////end refresh category.////////
                this.submitted=false;
          } );

        }else{
         $(window).scrollTop(0);
          this._flashMessagesService.show('Error: File size is over limit, maximum file size is 5mb', {cssClass: 'center-align flow-text card-title z-depth-2 white-text red darken-1', timeout:5000});
          this.submitted=false;
        }
  
      }

    }
}



// WEBPACK FOOTER //
// ./src/app/components/editroom/editroom.component.ts